"use client";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation, useMedia } from "react-use";

function Navbar({ handleSectionClick }) {
  const isMobileSize = useMedia("(max-width: 480px)");

  console.log("isMobileSize", isMobileSize);

  const shouldAddBg = window?.location?.href?.includes("view-pdf");
  function handleScroll() {
    const bodyScroll = window.scrollY;
    const navbar = document.querySelector(".navbar");

    if (bodyScroll > 300) navbar.classList.add("nav-scroll");
    else navbar.classList.remove("nav-scroll");
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // function handleDropdownMouseMove(event) {
  //   event.currentTarget.querySelector(".dropdown-menu").classList.add("show");
  // }

  // function handleDropdownMouseLeave(event) {
  //   event.currentTarget
  //     .querySelector(".dropdown-menu")
  //     .classList.remove("show");
  // }
  const location = useLocation();
  const name = location.pathname === "/" ? "View portfolio" : "Nithin AI";
  const nameUrl = location.pathname === "/" ? "/home" : "/";

  function handleToggleNav() {
    if (
      document
        .querySelector(".navbar .navbar-collapse")
        .classList.contains("show")
    ) {
      document
        .querySelector(".navbar .navbar-collapse")
        .classList.remove("show");
    } else if (
      !document
        .querySelector(".navbar .navbar-collapse")
        .classList.contains("show")
    ) {
      document.querySelector(".navbar .navbar-collapse").classList.add("show");
    }
  }
  return (
    <nav
      className="navbar navbar-expand-lg bord navblur"
      id="main-header"
      style={shouldAddBg ? { background: "#0f0f0f" } : {}}
    >
      <div className="container o-hidden">
        <Link className="logo icon-img-100" to="/home">
          <img
            src="/assets/imgs/nn-logo.png"
            alt="logo"
            style={{ width: "50px" }}
          />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleToggleNav}
        >
          <span className="icon-bar">
            <i className="fas fa-bars"></i>
          </span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <div
                className="nav-link"
                role="button"
                onClick={() => {
                  handleSectionClick(0);
                  handleToggleNav();
                }}
              >
                <Link to="/home">
                  <span className="rolling-text">Home</span>
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <div
                onClick={() => {
                  handleSectionClick(1);
                  handleToggleNav();
                }}
                className="nav-link"
                role="button"
              >
                <Link to="/home">
                  <span className="rolling-text">About Me</span>
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <div
                onClick={() => {
                  handleSectionClick(2);
                  handleToggleNav();
                }}
                className="nav-link"
                role="button"
              >
                <Link to="/home">
                  <span className="rolling-text">Case Studies</span>
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <div className="nav-link" role="button">
                <Link to="/contact">
                  <span className="rolling-text">Contact Me</span>
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <div className="nav-link" role="button">
                <a
                  className="rolling-text"
                  href="/assets/pdf/resume/Nithin Chandra Namani Resume.pdf"
                  target="_blank"
                >
                  <span className="text">Resume</span>
                </a>
              </div>
            </li>
            {isMobileSize && (
              <li className="nav-item">
                <div className="nav-link" role="button">
                  <Link className="rolling-text" to={nameUrl}>
                    <span className="text">{name}</span>
                  </Link>
                </div>
              </li>
            )}
          </ul>
        </div>

        <div className="contact-button">
          <Link
            className="butn butn-sm butn-bg main-colorbg radius-5"
            to={nameUrl}
          >
            <span className="text">{name}</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
